module.exports = __webpack_public_path__ + "static/media/lead_generated_card_corner.721f51c6.svg";